<template>
  <section>
    <div class="row mt-2">
      <div class="col">
        <z-textarea v-model="newComment" label="Leave a Comment" @keyup="highlightSave" />
      </div>
    </div>
    <div class="row mt-1">
      <div class="col">
        <button
          class="btn btn-success btn-sm"
          :class="{ 'btn-danger': isSave }"
          @click="submitComment"
        >
          Submit
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-1"></div>
      <div class="col">
        <div class="custom-comment-wrapper">
          <ul class="custom-comment-list">
            <li v-for="item of comments" :key="item.blogComment" class="custom-comment-record">
              <div class="row mt-2">
                <div class="col">
                  <span class="custom-name">{{ item.createdByName }}</span
                  ><span class="custom-date">{{ formatDateTime(item.createdOn) }}</span>
                </div>
                <div v-if="isAuthor" class="col-1">
                  <button class="btn btn-link" @click="removeComment(item)">remove</button>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <confirm-action
      v-model="actionRemove"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      :d-style="'z-index: 1070'"
      :bd-style="'z-index: 1065'"
      @closing="close"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { blogStore } from '@/stores/blog'
import ZTextarea from '@/components/utilities/elements/TextArea.vue'
import ConfirmAction from '@/components/utilities/elements/ConfirmDialog.vue'
import moment from 'moment'
export default {
  name: 'BlogComments',
  components: {
    ZTextarea,
    ConfirmAction
  },
  props: {
    blog: Object
  },
  data() {
    return {
      newComment: null,
      comment: null,
      isSave: false,
      actionRemove: null,
      confirmTitle: 'Remove',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to delete this comment?'
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(blogStore, ['comments']),
    isAuthor() {
      let _is = false
      if (this.blog) {
        if (this.profile) {
          if (parseInt(this.blog.createdBy) === parseInt(this.profile.contact)) {
            _is = true
          }
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions(blogStore, ['getComments', 'saveComment', 'deleteComment']),
    async init() {
      this.actionRemove = null
      this.newComment = null
      this.isSave = false
      await this.getComments(this.blog.blog)
    },
    formatDateTime(createdOn) {
      return moment(createdOn).format('dddd, MMMM Do YYYY, h:mm:ss a')
    },
    close() {
      this.actionRemove = null
    },
    commentInfo(comment) {
      let results = null
      if (comment) {
        results = `${comment.createdByName} on ${moment(comment.createdOn).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        )}`
      }
      return results
    },
    async submitComment() {
      if (this.isSave) {
        let data = {
          blog: this.blog.blog,
          createdBy: this.profile.user,
          content: this.newComment
        }
        await this.saveComment(data)
        this.init()
      }
    },
    removeComment(item) {
      this.comment = item
      this.actionRemove = item
    },
    async performDelete() {
      if (this.comment) {
        console.log('Delete Comment', this.comment)
        await this.deleteComment(this.comment.blogComment)
      }
      await this.getComments(this.blog.blog)
      this.comment = null
      this.actionRemove = null
    },
    highlightSave() {
      this.isSave = true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-comment-wrapper {
  margin-top: 10px;
  height: 200px;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  border: 1px solid #ced4da;
}
.custom-comment-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-comment-record {
  border-bottom: 1px solid #ced4da;
}
.custom-name {
  font-size: 1.1em;
  font-weight: 600;
}
.custom-date {
  color: #474747;
  margin-left: 5px;
  font-size: 0.9em;
}
</style>
